import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Col, Row } from '../../../../Shared/Grid'
import Mapping from './Mapping'
import './styles.scss'

const MAPPING_REQUIRES_NO_CHAIN_CODE = {
  27: 1,
  29: 1,
  680: 1
}

class EditMappings extends PureComponent {
  state = {
    mappingsMap: {},
    mappingValidation: {}
  }

  componentDidMount () {
    this.populateFromProps()
  }

  componentDidUpdate (prevProps) {
    if (prevProps !== this.props) {
      this.populateFromProps()
    }
  }

  populateFromProps () {
    const mappingsMap = {}
    this.props.mappings.forEach((mapping) => {
      mappingsMap[mapping.supplierId] = mapping
    })
    this.setState({ mappingsMap })
  }

  onMappingValidationChange (id, isValid) {
    this.setState((prevState) => ({
      mappingValidation: { ...prevState.mappingValidation, [id]: isValid }
    }), () => {
      const isNotValid = Object.keys(this.state.mappingValidation).some(k => !this.state.mappingValidation[k])
      this.props.onValidation(!isNotValid)
    })
  }

  onMappingChange = (mapping) => {
    const mappings = Object.keys(this.state.mappingsMap).map(e => this.state.mappingsMap[e])
    let index = mappings.findIndex(i => i.supplierId === mapping.supplierId)
    if (index > -1) {
      const newMappings = [...mappings]
      newMappings[index] = mapping
      this.props.onMappingsChange(newMappings)
    } else {
      const newMappings = [...mappings]
      newMappings.push(mapping)
      this.props.onMappingsChange(newMappings)
    }
  }

  onMappingRemove = (mappingId) => {
    const mappings = Object.keys(this.state.mappingsMap).map(e => this.state.mappingsMap[e])
    let index = mappings.findIndex(i => i.supplierId === mappingId)
    if (index > -1) {
      const newMappings = [...mappings]
      newMappings.splice(index, 1)
      this.props.onMappingsChange(newMappings)
    }
  }

  createMappingRow (mapping) {
    const mappingValue = this.state.mappingsMap.hasOwnProperty(mapping.id) ?
      this.state.mappingsMap[mapping.id] : undefined
    return (
      <Row key={mapping.id}>
        <Mapping mapping={mapping}
                 chainCodeRequired={!MAPPING_REQUIRES_NO_CHAIN_CODE.hasOwnProperty(mapping.id)}
                 mappingValue={mappingValue}
                 onChange={this.onMappingChange}
                 onRemove={this.onMappingRemove}
                 onValidationChange={(isValid) => this.onMappingValidationChange(mapping.id, isValid)}
        />
      </Row>
    )
  }

  render () {
    return (
      <div className="edit-property-mappings">
        <Row>
          <Col><h3 className="edit-property-heading">Mapping Information</h3></Col>
        </Row>
        {this.props.allowedMappings.map(mapping => this.createMappingRow(mapping))}
      </div>
    )
  }
}

EditMappings.propTypes = {
  mappings: PropTypes.array.isRequired,
  onMappingsChange: PropTypes.func.isRequired,
  onValidation: PropTypes.func.isRequired,
  allowedMappings: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired).isRequired
}
export default withTranslation()(EditMappings)
